import { csx } from '@vtex/admin-ui'

export const styles = {
  modalContent: csx({
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-4',
    paddingTop: '0',
  }),
  nestedContainer: csx({
    marginTop: '$space-4',
    paddingLeft: '$space-7',
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-4',
  }),
  modalFooter: csx({
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '$space-5',
  }),
}
